import { API_AUTH } from "./common";

const DanhSachKhachHangApi = {
  list: ({
    tenKH,
    loaiKH,
    tinhtrangKH,
    trangthaiKH,
    nguonKH,
    pageIndex,
    pageSize,
  }) =>
    API_AUTH.get(
      `quanlykhachhang/danh-sach-khach-hang?tenKH=${tenKH}&loaiKH=${loaiKH}&tinhtrangKH=${tinhtrangKH}&trangthaiKH=${trangthaiKH}&nguonKH=${nguonKH}&pageIndex=${pageIndex}&pageSize=${pageSize}`,
      {}
    ),

    xoaKhachHang:(customerId)=>API_AUTH.post(`quanlykhachhang/xoa-khach-hang?customerId=${customerId}`,{}),
};



export default DanhSachKhachHangApi;
